import { supabase } from '../config/supabase';

export type FinancialCatalogKind = 'service' | 'organization' | 'payer_link' | 'pricing_rule'
  | 'cash_account' | 'package_template' | 'professional_role' | 'settlement_rule' | 'absence_policy' | 'contract';

/** Removes a catalog entry from future use; used organizations/payers become inactive. */
export async function archiveFinancialCatalogRecord(input: {
  clientId: string; kind: FinancialCatalogKind; recordId: string;
}): Promise<void> {
  if (input.kind === 'contract') throw new Error('Contratos não podem ser excluídos. Encerre a vigência para mantê-los em Inativos.');
  const { error } = await supabase.rpc('financial_catalog_archive', {
    p_client_id: input.clientId,
    p_kind: input.kind,
    p_record_id: input.recordId,
  });
  if (!error) return;
  if (error.code === '42501') throw new Error('Seu perfil não permite excluir este cadastro financeiro.');
  if (error.code === 'PGRST202' || error.code === '42883') {
    throw new Error('A atualização de edição e exclusão dos cadastros financeiros ainda precisa ser aplicada no banco (42a).');
  }
  throw new Error(error.message || 'Não foi possível excluir o cadastro financeiro.');
}
